import React from 'react';
import { NextPage } from 'next';
import Layout from '../../components/layout';
import GenericContainer from '../../components/@container/generic-container';
import Link from '../../components/link';

const OwnersPage: NextPage = () => (
  <Layout title="Owner's Literature and Information">
    <GenericContainer
      title="Owner's Literature and Information"
      breadcrumb={{ url: '/', text: 'Back to Home' }}
    >
      <div className="content">
        <p>Please choose one of the following options.</p>
        <div className="bookstores">
          <Link href="/owners/literature">
            <a className="bookstore-tile">
              <span className="click-icon">
                <i className="fas fa-arrow-alt-circle-right" />
              </span>
              Owner&apos;s Literature
            </a>
          </Link>
          <Link href="/owners/compliance-letter">
            <a className="bookstore-tile">
              <span className="click-icon">
                <i className="fas fa-arrow-alt-circle-right" />
              </span>
              Compliance Letter
            </a>
          </Link>
          <Link href="/owners/whats-new">
            <a className="bookstore-tile">
              <span className="click-icon">
                <i className="fas fa-arrow-alt-circle-right" />
              </span>
              What&apos;s New
            </a>
          </Link>
        </div>
      </div>
      {/* languages=CSS */}
      <style jsx>{`
        p {
          font-family: 'Volvo Novum', sans-serif;
        }

        .bookstores {
          display: grid;
          align-items: center;
        }

        .bookstore-tile {
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          text-decoration: none;
          color: #333;
          padding: 1rem;
          margin-bottom: 0.5rem;
          cursor: pointer;
        }

        .bookstore-tile:hover {
          background-color: #eee;
        }

        .click-icon {
          float: left;
          padding-right: 2rem;
        }
      `}</style>
    </GenericContainer>
  </Layout>
);

export default OwnersPage;
